<div hidden class="version">{{ version }}-{{ environment }}</div>
<ng-container *ngIf="isStandaloneStartup$ | async; else content">
  <div class="spinner-container">
    <span class="spinner"></span>
  </div>
</ng-container>
<ng-template #content>
  <div
    *ngIf="showContent$ | async"
    [class.sk]="showSkeleton$ | async"
    [class.environment-lbl]="showEnvironmentLabel"
    [class.standalone]="loadedStandalone"
    [class.ios]="mobileService.isIOSDevice()"
    class="relative">
    <div class="content-wrapper" [class.signed-out]="(isSignedIn$ | async) === false">
      <yat-button-close-modal id="de746309-4d62-4a27-9c8c-43e37b1fc669" (clickMethod)="closeApp()"> </yat-button-close-modal>
      <div class="relative">
        <header>
          <ng-container [ngSwitch]="header$ | async">
            <div
              [ngClass]="(headerExpanded$ | async) ? 'header-expanded' : 'header-minified'"
              [class.notification-active]="(hasNotifications$ | async) && (showNotifications$ | async)">
              <yat-notification-outlet id="2a530484-216c-43d3-b681-104abcf1ae33" [showLineOnTop]="true" class="" *ngIf="showNotifications$ | async"></yat-notification-outlet>
              <yat-simple-header *ngSwitchCase="'simple'"></yat-simple-header>
              <yat-academic-header *ngSwitchCase="'academic'"></yat-academic-header>
              <yat-commercial-header *ngSwitchCase="'commercial'"></yat-commercial-header>
            </div>
          </ng-container>
        </header>
        <main role="main" class="main-site">
          <div [class.container]="applyContainer$ | async">
            <router-outlet></router-outlet>
          </div>
        </main>
        <yat-desktop-drawer-dialog id="747aef16-527e-4f8e-b870-254a2cab40fa"></yat-desktop-drawer-dialog>
      </div>
    </div>
    <yat-bottom-row id="dbb751bf-d5cd-4c24-a85a-02be88cd1fcc" *ngIf="showFooter()" class="bottom-row"></yat-bottom-row>
  </div>
  <yat-environment-label id="c871d1ae-57c0-4f1b-884a-7a7681ac6a49" class="webshop" *ngIf="showEnvironmentLabel"> </yat-environment-label>
  <div class="backdrop" *ngIf="showBackdrop$ | async"></div>
</ng-template>
